import type { Environments } from '@app/core/environment-service';
import { ENVIRONMENTS_DEFAULT_FAST } from '@app/core/environment-service';
import { getStageBackBoneUrl, getStageFastGateway, normalizeHost } from '@app/shared/utils';
import { getLocation } from '@app/shared/utils/location';

import { resolveStageBetbyConfig } from './betby-stack.util';

export const location = getLocation('csgofast.com');
export const environment: Environments = {
  ...ENVIRONMENTS_DEFAULT_FAST,
  production: false,
  hmr: true,
  PROJECT: 'csgofast',
  BUILD_NAME: 'stage-client',
  HOSTNAME: `${location.host}`,
  SITE_NAME: 'CSGOFast',
  // ONE stage bundle serves both numbered-stand domains of a worker, so the Betby stack follows the
  // backend the same host-based way as GATEWAY_URL below: *.devfast.io stands (dev backend) → BETA
  // stack, csgofast4 stagings / local stage (stage-prod backend) → PRODUCTION stack. A static prod
  // config here killed the dev-stand integration (prod script + dev-signed player token).
  BETBY: resolveStageBetbyConfig(location.hostname),
  // ---------- URLS
  WS_GATEWAY_URL: getStageFastGateway(location.hostname),
  GATEWAY_URL: getStageFastGateway(location.hostname),
  BACKBONE_URL: getStageBackBoneUrl(location.host),
  ESPORTS_API_URL: 'stage',
  PAYMENT_URL: getStageFastGateway(location.hostname),
  PAYMENT_URL_2: getStageFastGateway(location.hostname),
  WITHDRAWAL_URL: getStageFastGateway(location.hostname),
  POGGI_URL: `https://poggi.${normalizeHost(location.hostname)}`,
  HILO_URL: 'https://d1phhoo4f618zo.cloudfront.net',
  CAN_ADD_LOBBY_SEO_PAGES: true,
  EXTERNAL_SEO_DOMAINS: [
    { domain: 'csgo-fast.pl', lang: 'pl', prefix: '/pl' },
    { domain: 'csgofast123.com', lang: 'tr', prefix: '/tr' },
  ],
  MARKETING_EVENT_ID: 49,
  EXTRA_MARKETING_EVENT_ID: 45,
  // ---------- MODULES
  MODULES: {
    ...ENVIRONMENTS_DEFAULT_FAST.MODULES,
    transaction: {
      refill: [],
      withdrawal: [],
    },
    account: {
      main: [],
      balance: [],
      referrals: [],
    },
    faq: true,
    soundToggler: true,
    inventory: {},
    games: [
      'classic',
      'case-battle',
      'double',
      'poggi',
      'hilo',
      'x50',
      'crash',
      'slot',
      'tower',
      'cases',
      // 'match-bets',
      'upgrader',
      'upgrade',
      'tickets',
    ],
    vip: true,
  },
};
/** Маршруты в текущем проекте (Ангуляр) */
const excludesRoutesHome = [
  // '/',
  '/block',
  '/not-found',
  '/game/cases',
  '/game/case-battle',
  '/game/classic',
  '/game/hilo',
  '/game/double',
  '/game/upgrader',
  '/game/upgrader/history',
  '/game/poggi',
  '/game/x50',
  '/game/crash',
  '/game/slot',
  '/events/ny',
  '/events',
  '/events/ny-event',
  '/events/ny-all-event',
  '/support',
  '/support/requests',
  '/store',
  '/withdrawal',
  '/withdrawal/method',
  '/(modal:transaction/withdrawal)',
  '/(modal:transaction/refill)',
  '/refill',
  '/inventory',
  '/faq',
  '/account',
  '/tos',
  '/anti-bribery-policy',
  '/privacy-policy',
  '/aml-policy',
  '/refund-policy',
  '/tickets',
  '/free-coins',
  '/free-coins/hilo',
  '/free-coins/x50',
  '/free-coins/double',
  '/bug-bounty',
];

const excludesRoutesFrame = ['/service-route'];
/** для формирования маршрутов в ангуляре */

const legacyRoutes = [
  'championship/crash',
  'history/crash',
  'history/crash/all',
  'history/crash/all/:id',
  'history/crash/personal',
  'history/crash/personal/:id',
  'service-route',
];

/** для маршрутизации из ангуляра */
const MatchedRoutesToBB: Record<string, string> = {
  '/game/tower': 'tower',
};

const SpecialGameRoutesToBB: Record<string, string> = {};

const MatchedRoutesFromBB: Record<string, string> = {
  '/refill': 'refill',
  '/withdrawal': 'withdrawal',
  '/support': '/support',
  '/event': '/events',
  '/event/ny-all': '/events/ny-all-event',
  '/event/quests': '/events/quests',
  '/anniversary': '/anniversary',
  '/11years': '/11years',
  '/fifa': '/fifa',
};
const SpecialPartRoutesFrmBB: string[] = ['/faq'];
const legacySeoKeys: Record<string, string> = {
  'history/crash': 'HISTORY_CRASH',
};
export const bbConfig = {
  excludesRoutesHome,
  excludesRoutesFrame,
  legacyRoutes,
  MatchedRoutesToBB,
  SpecialGameRoutesToBB,
  MatchedRoutesFromBB,
  SpecialPartRoutesFrmBB,
  legacySeoKeys,
};
